// deps
import React from "react";

// interfaces
import { BankListData } from "@payment-client/interfaces/PaymentApi";

export interface NetbankingMoreBanksContextValue {
    bankList: BankListData["bankList"];
}

export const NetbankingMoreBanksContext = React.createContext<NetbankingMoreBanksContextValue>({
    bankList: [],
});

if (__DEV__) {
    NetbankingMoreBanksContext.displayName = "NetbankingMoreBanksContext";
}
